module.exports = __webpack_public_path__ + "fonts/DM_Sans-300-latin7.3ccd9ab.woff2";